// @vendors
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');

const searchWidgetEmptyStateRetry = (handleRetry) => {
    const lostConnectionFirstLine = formatText(
        'brokerSearchWidget-brokerSearchWidget_searchFailedText'
    );
    const retryButton = (
        <OKButton onClick={handleRetry} modifier="secondary">
            <FormattedText value="broker-retry" />
        </OKButton>
    );

    return <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-wealth"/>
}

module.exports = searchWidgetEmptyStateRetry;